module.exports = __webpack_public_path__ + "static/media/retrato_3.f5c8ff0e.jpg";